import { useSettings } from '@wix/tpa-settings/react';

import {
  useAppSettings,
  useCanEditMember,
  useMember,
  useSite,
} from '../../../../contexts/widgets';
import type { ControllerProps } from '../../../../types';
import {
  SettingsSection,
  SettingsSectionState,
  SettingsTab,
} from '../../../../types';
import settingsParams from '../../settingsParams';
import { getIsBlogContributor } from './utils';

export const shouldForceEmptyState = ({
  tabOpened,
  sectionOpened,
  sectionState,
}: ControllerProps['appSettings']) => {
  return (
    tabOpened === SettingsTab.Sections &&
    sectionOpened === SettingsSection.PostList &&
    sectionState === SettingsSectionState.Empty
  );
};

const shouldRenderBlogPosts = (
  showBlogPostsSection: boolean,
  hasBlogContent: boolean,
  hasBlogContributorPermissions: boolean,
) => {
  return (
    showBlogPostsSection && hasBlogContent && hasBlogContributorPermissions
  );
};

export const useBlogPostsRendered = () => {
  const settings = useSettings();
  const appSettings = useAppSettings();
  const { roles, blogPosts } = useMember();
  const { canEditMember } = useCanEditMember();
  const { isBlogInstalled } = useSite();

  const showBlogPostsSection = settings.get(
    settingsParams.showBlogPostsSection,
  );
  const hasBlogContent =
    canEditMember || shouldForceEmptyState(appSettings) || blogPosts.length > 0;
  const hasBlogContributorPermissions = getIsBlogContributor(
    isBlogInstalled,
    roles,
  );

  return {
    shouldRenderBlogPosts: shouldRenderBlogPosts(
      showBlogPostsSection,
      hasBlogContent,
      hasBlogContributorPermissions,
    ),
  };
};
